// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__36u4O","insightsList":"newBusinessInsightsMenu_insightsList__2d7yp","active":"newBusinessInsightsMenu_active__2y1xz"};